import { ProjectRoles, WorkspaceUserRoles } from './enums';
export const enumColors = {
    light: [
        '#cfdffe',
        '#d0f1fd',
        '#c2f5e8',
        '#ffdaf6',
        '#ffdce5',
        '#fee2d5',
        '#ffeab6',
        '#d1f7c4',
        '#ede2fe',
        '#eeeeee',
    ],
    dark: [
        '#2d7ff999',
        '#18bfff99',
        '#20d9d299',
        '#ff08c299',
        '#f82b6099',
        '#ff6f2c99',
        '#fcb40099',
        '#20c93399',
        '#8b46ff99',
        '#666',
    ],
    get: (theme, index) => {
        index = Math.abs(index) % enumColors[theme].length;
        return enumColors[theme][index];
    },
};
export var ViewTypes;
(function (ViewTypes) {
    ViewTypes[ViewTypes["FORM"] = 1] = "FORM";
    ViewTypes[ViewTypes["GALLERY"] = 2] = "GALLERY";
    ViewTypes[ViewTypes["GRID"] = 3] = "GRID";
    ViewTypes[ViewTypes["KANBAN"] = 4] = "KANBAN";
    ViewTypes[ViewTypes["MAP"] = 5] = "MAP";
    ViewTypes[ViewTypes["CALENDAR"] = 6] = "CALENDAR";
    ViewTypes[ViewTypes["LIST"] = 7] = "LIST";
})(ViewTypes || (ViewTypes = {}));
export const viewTypeAlias = {
    [ViewTypes.FORM]: 'form',
    [ViewTypes.GALLERY]: 'gallery',
    [ViewTypes.GRID]: 'grid',
    [ViewTypes.KANBAN]: 'kanban',
    [ViewTypes.MAP]: 'map',
    [ViewTypes.CALENDAR]: 'calendar',
    [ViewTypes.LIST]: 'list',
};
export const viewTypeToStringMap = Object.assign({}, viewTypeAlias);
// Generate reverse mapping from the original viewTypeAlias
export const stringToViewTypeMap = Object.entries(viewTypeAlias).reduce((acc, [key, value]) => {
    acc[value] = Number(key);
    return acc;
}, {});
export const VIEW_GRID_DEFAULT_WIDTH = 200;
export var ProjectTypes;
(function (ProjectTypes) {
    ProjectTypes["DATABASE"] = "database";
    ProjectTypes["DOCUMENTATION"] = "documentation";
    ProjectTypes["COWRITER"] = "cowriter";
    ProjectTypes["DASHBOARD"] = "dashboard";
})(ProjectTypes || (ProjectTypes = {}));
export var RelationTypes;
(function (RelationTypes) {
    RelationTypes["HAS_MANY"] = "hm";
    RelationTypes["BELONGS_TO"] = "bt";
    RelationTypes["MANY_TO_MANY"] = "mm";
    RelationTypes["ONE_TO_ONE"] = "oo";
    RelationTypes["ONE_TO_MANY"] = "om";
    RelationTypes["MANY_TO_ONE"] = "mo";
})(RelationTypes || (RelationTypes = {}));
export var LinksVersion;
(function (LinksVersion) {
    LinksVersion[LinksVersion["V1"] = 1] = "V1";
    LinksVersion[LinksVersion["V2"] = 2] = "V2";
})(LinksVersion || (LinksVersion = {}));
export const ExpandedFormMode = {
    FIELD: 'field',
    ATTACHMENT: 'attachment',
    DISCUSSION: 'discussion',
};
export var ExportTypes;
(function (ExportTypes) {
    ExportTypes["EXCEL"] = "excel";
    ExportTypes["CSV"] = "csv";
    ExportTypes["JSON"] = "json";
})(ExportTypes || (ExportTypes = {}));
export var PluginCategory;
(function (PluginCategory) {
    PluginCategory["STORAGE"] = "Storage";
    PluginCategory["EMAIL"] = "Email";
})(PluginCategory || (PluginCategory = {}));
export var ModelTypes;
(function (ModelTypes) {
    ModelTypes["TABLE"] = "table";
    ModelTypes["VIEW"] = "view";
    ModelTypes["DASHBOARD"] = "dashboard";
})(ModelTypes || (ModelTypes = {}));
export var AutomationTypes;
(function (AutomationTypes) {
    AutomationTypes["SCRIPT"] = "script";
    AutomationTypes["WORKFLOW"] = "workflow";
})(AutomationTypes || (AutomationTypes = {}));
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["JOB"] = "job";
})(ProjectStatus || (ProjectStatus = {}));
export var TiptapNodesTypes;
(function (TiptapNodesTypes) {
    TiptapNodesTypes["doc"] = "doc";
    TiptapNodesTypes["sec"] = "sec";
    TiptapNodesTypes["paragraph"] = "paragraph";
    TiptapNodesTypes["text"] = "text";
    TiptapNodesTypes["heading"] = "heading";
    TiptapNodesTypes["bullet"] = "bullet";
    TiptapNodesTypes["ordered"] = "ordered";
    TiptapNodesTypes["task"] = "task";
    TiptapNodesTypes["quote"] = "quote";
    TiptapNodesTypes["divider"] = "divider";
    TiptapNodesTypes["codeBlock"] = "codeBlock";
    TiptapNodesTypes["image"] = "image";
    TiptapNodesTypes["callout"] = "callout";
    TiptapNodesTypes["tipCallout"] = "tipCallout";
    TiptapNodesTypes["table"] = "table";
    TiptapNodesTypes["tableRow"] = "tableRow";
    TiptapNodesTypes["tableCell"] = "tableCell";
    TiptapNodesTypes["embed"] = "embed";
    TiptapNodesTypes["collapsable"] = "collapsable";
    TiptapNodesTypes["collapsableContent"] = "collapsable_content";
    TiptapNodesTypes["collapsableHeader"] = "collapsable_header";
    TiptapNodesTypes["column"] = "column";
    TiptapNodesTypes["columnContent"] = "columnContent";
    TiptapNodesTypes["linkToPage"] = "linkToPage";
    TiptapNodesTypes["attachment"] = "attachment";
})(TiptapNodesTypes || (TiptapNodesTypes = {}));
export var TiptapMarksTypes;
(function (TiptapMarksTypes) {
    TiptapMarksTypes["strike"] = "strike";
    TiptapMarksTypes["bold"] = "bold";
    TiptapMarksTypes["italic"] = "italic";
    TiptapMarksTypes["link"] = "link";
    TiptapMarksTypes["code"] = "code";
    TiptapMarksTypes["underline"] = "underline";
})(TiptapMarksTypes || (TiptapMarksTypes = {}));
export var NcDataErrorCodes;
(function (NcDataErrorCodes) {
    NcDataErrorCodes["NC_ERR_MM_MODEL_NOT_FOUND"] = "NC_ERR_MM_MODEL_NOT_FOUND";
})(NcDataErrorCodes || (NcDataErrorCodes = {}));
export var NcErrorType;
(function (NcErrorType) {
    NcErrorType["ERR_AUTHENTICATION_REQUIRED"] = "ERR_AUTHENTICATION_REQUIRED";
    NcErrorType["ERR_FORBIDDEN"] = "ERR_FORBIDDEN";
    NcErrorType["ERR_API_TOKEN_NOT_ALLOWED"] = "ERR_API_TOKEN_NOT_ALLOWED";
    NcErrorType["ERR_WORKSPACE_NOT_FOUND"] = "ERR_WORKSPACE_NOT_FOUND";
    NcErrorType["ERR_BASE_NOT_FOUND"] = "ERR_BASE_NOT_FOUND";
    NcErrorType["ERR_SOURCE_NOT_FOUND"] = "ERR_SOURCE_NOT_FOUND";
    NcErrorType["ERR_TABLE_NOT_FOUND"] = "ERR_TABLE_NOT_FOUND";
    NcErrorType["ERR_VIEW_NOT_FOUND"] = "ERR_VIEW_NOT_FOUND";
    NcErrorType["ERR_FIELD_NOT_FOUND"] = "ERR_FIELD_NOT_FOUND";
    NcErrorType["ERR_RECORD_NOT_FOUND"] = "ERR_RECORD_NOT_FOUND";
    NcErrorType["ERR_GENERIC_NOT_FOUND"] = "ERR_GENERIC_NOT_FOUND";
    NcErrorType["ERR_HOOK_NOT_FOUND"] = "ERR_HOOK_NOT_FOUND";
    NcErrorType["ERR_REQUIRED_FIELD_MISSING"] = "ERR_REQUIRED_FIELD_MISSING";
    NcErrorType["ERR_DUPLICATE_RECORD"] = "ERR_DUPLICATE_RECORD";
    NcErrorType["ERR_USER_NOT_FOUND"] = "ERR_USER_NOT_FOUND";
    NcErrorType["ERR_TEAM_NOT_FOUND"] = "ERR_TEAM_NOT_FOUND";
    NcErrorType["ERR_INVALID_OFFSET_VALUE"] = "ERR_INVALID_OFFSET_VALUE";
    NcErrorType["ERR_INVALID_PAGE_VALUE"] = "ERR_INVALID_PAGE_VALUE";
    NcErrorType["ERR_INVALID_LIMIT_VALUE"] = "ERR_INVALID_LIMIT_VALUE";
    NcErrorType["ERR_INVALID_FILTER"] = "ERR_INVALID_FILTER";
    NcErrorType["ERR_INVALID_SHARED_VIEW_PASSWORD"] = "ERR_INVALID_SHARED_VIEW_PASSWORD";
    NcErrorType["ERR_INVALID_ATTACHMENT_JSON"] = "ERR_INVALID_ATTACHMENT_JSON";
    NcErrorType["ERR_NOT_IMPLEMENTED"] = "ERR_NOT_IMPLEMENTED";
    NcErrorType["ERR_INTERNAL_SERVER"] = "ERR_INTERNAL_SERVER";
    NcErrorType["ERR_DATABASE_OP_FAILED"] = "ERR_DATABASE_OP_FAILED";
    NcErrorType["ERR_UNKNOWN"] = "ERR_UNKNOWN";
    NcErrorType["ERR_INVALID_JSON"] = "ERR_INVALID_JSON";
    NcErrorType["ERR_INVALID_PK_VALUE"] = "ERR_INVALID_PK_VALUE";
    NcErrorType["ERR_COLUMN_ASSOCIATED_WITH_LINK"] = "ERR_COLUMN_ASSOCIATED_WITH_LINK";
    NcErrorType["ERR_TABLE_ASSOCIATED_WITH_LINK"] = "ERR_TABLE_ASSOCIATED_WITH_LINK";
    NcErrorType["ERR_INTEGRATION_NOT_FOUND"] = "ERR_INTEGRATION_NOT_FOUND";
    NcErrorType["ERR_INTEGRATION_LINKED_WITH_BASES"] = "ERR_INTEGRATION_LINKED_WITH_BASES";
    NcErrorType["ERR_FORMULA"] = "ERR_FORMULA";
    NcErrorType["ERR_CIRCULAR_REF_IN_FORMULA"] = "ERR_CIRCULAR_REF_IN_FORMULA";
    NcErrorType["ERR_PERMISSION_DENIED"] = "ERR_PERMISSION_DENIED";
    NcErrorType["ERR_INVALID_ATTACHMENT_UPLOAD_SCOPE"] = "ERR_INVALID_ATTACHMENT_UPLOAD_SCOPE";
    NcErrorType["ERR_CANNOT_CALCULATE_INTERMEDIATE_ORDER"] = "ERR_CANNOT_CALCULATE_INTERMEDIATE_ORDER";
    NcErrorType["ERR_REORDER_FAILED"] = "ERR_REORDER_FAILED";
    NcErrorType["ERR_PLAN_LIMIT_EXCEEDED"] = "ERR_PLAN_LIMIT_EXCEEDED";
    NcErrorType["ERR_FEATURE_NOT_SUPPORTED"] = "ERR_FEATURE_NOT_SUPPORTED";
    NcErrorType["ERR_SSO_LOGIN_REQUIRED"] = "ERR_SSO_LOGIN_REQUIRED";
    NcErrorType["ERR_SSO_GENERATED_TOKEN_REQUIRED"] = "ERR_SSO_GENERATED_TOKEN_REQUIRED";
    NcErrorType["ERR_MAX_PAYLOAD_LIMIT_EXCEEDED"] = "ERR_MAX_PAYLOAD_LIMIT_EXCEEDED";
    NcErrorType["ERR_INVALID_VALUE_FOR_FIELD"] = "ERR_INVALID_VALUE_FOR_FIELD";
    NcErrorType["ERR_MAX_WORKSPACE_LIMIT_REACHED"] = "ERR_MAX_WORKSPACE_LIMIT_REACHED";
    NcErrorType["ERR_BASE_COLLABORATION"] = "ERR_BASE_COLLABORATION";
    NcErrorType["ERR_ORG_USER"] = "ERR_ORG_USER";
    NcErrorType["ERR_SYNC_TABLE_OPERATION_PROHIBITED"] = "ERR_SYNC_TABLE_OPERATION_PROHIBITED";
    NcErrorType["ERR_INVALID_REQUEST_BODY"] = "ERR_INVALID_REQUEST_BODY";
    NcErrorType["ERR_DASHBOARD_NOT_FOUND"] = "ERR_DASHBOARD_NOT_FOUND";
    NcErrorType["ERR_WORKFLOW_NOT_FOUND"] = "ERR_WORKFLOW_NOT_FOUND";
    NcErrorType["ERR_WIDGET_NOT_FOUND"] = "ERR_WIDGET_NOT_FOUND";
    NcErrorType["ERR_VIEW_SECTION_NOT_FOUND"] = "ERR_VIEW_SECTION_NOT_FOUND";
    NcErrorType["ERR_SHARED_DASHBOARD_PASSWORD_INVALID"] = "ERR_SHARED_DASHBOARD_PASSWORD_INVALID";
    NcErrorType["ERR_DUPLICATE_IN_ALIAS"] = "ERR_DUPLICATE_IN_ALIAS";
    NcErrorType["ERR_OUT_OF_SYNC"] = "ERR_OUT_OF_SYNC";
    NcErrorType["ERR_FILTER_VERIFICATION_FAILED"] = "ERR_FILTER_VERIFICATION_FAILED";
    NcErrorType["ERR_VIEW_COLUMN_NOT_FOUND"] = "ERR_VIEW_COLUMN_NOT_FOUND";
    NcErrorType["ERR_WEBHOOK_ERROR"] = "ERR_WEBHOOK_ERROR";
    NcErrorType["ERR_WEBHOOK_URL_INVALID"] = "ERR_WEBHOOK_URL_INVALID";
    NcErrorType["ERR_BASE_OP_FAILED"] = "ERR_BASE_OP_FAILED";
    NcErrorType["ERR_TABLE_OP_FAILED"] = "ERR_TABLE_OP_FAILED";
    NcErrorType["ERR_COLUMN_OP_FAILED"] = "ERR_COLUMN_OP_FAILED";
    NcErrorType["ERR_DATA_SOURCES_NOT_FOUND"] = "ERR_DATA_SOURCES_NOT_FOUND";
    NcErrorType["ERR_TEST_PLUGIN_FAILED"] = "ERR_TEST_PLUGIN_FAILED";
    NcErrorType["ERR_UNSUPPORTED_RELATION"] = "ERR_UNSUPPORTED_RELATION";
    NcErrorType["ERR_IN_EXTERNAL_DATA_SOURCE"] = "ERR_IN_EXTERNAL_DATA_SOURCE";
    NcErrorType["ERR_EXTERNAL_DATA_SOURCE_TIMEOUT"] = "ERR_EXTERNAL_DATA_SOURCE_TIMEOUT";
    NcErrorType["ERR_RELATION_FIELD_NOT_FOUND"] = "ERR_RELATION_FIELD_NOT_FOUND";
    NcErrorType["ERR_UNSUPPORTED_FILTER_OPERATION"] = "ERR_UNSUPPORTED_FILTER_OPERATION";
    NcErrorType["ERR_STORAGE_FILE_CREATE"] = "ERR_STORAGE_FILE_CREATE";
    NcErrorType["ERR_STORAGE_FILE_READ"] = "ERR_STORAGE_FILE_READ";
    NcErrorType["ERR_STORAGE_FILE_DELETE"] = "ERR_STORAGE_FILE_DELETE";
    NcErrorType["ERR_STORAGE_FILE_STREAM"] = "ERR_STORAGE_FILE_STREAM";
    NcErrorType["ERR_PLAN_ALREADY_EXISTS"] = "ERR_PLAN_ALREADY_EXISTS";
    NcErrorType["ERR_SUBSCRIPTION_ALREADY_EXISTS"] = "ERR_SUBSCRIPTION_ALREADY_EXISTS";
    NcErrorType["ERR_SUBSCRIPTION_NOT_FOUND"] = "ERR_SUBSCRIPTION_NOT_FOUND";
    NcErrorType["ERR_PLAN_NOT_AVAILABLE"] = "ERR_PLAN_NOT_AVAILABLE";
    NcErrorType["ERR_SEAT_COUNT_MISMATCH"] = "ERR_SEAT_COUNT_MISMATCH";
    NcErrorType["ERR_INVALID_PAYMENT_PAYLOAD"] = "ERR_INVALID_PAYMENT_PAYLOAD";
    NcErrorType["ERR_STRIPE_CUSTOMER_NOT_FOUND"] = "ERR_STRIPE_CUSTOMER_NOT_FOUND";
    NcErrorType["ERR_STRIPE_SUBSCRIPTION_NOT_FOUND"] = "ERR_STRIPE_SUBSCRIPTION_NOT_FOUND";
    NcErrorType["ERR_SUBSCRIPTION_OWNERSHIP_MISMATCH"] = "ERR_SUBSCRIPTION_OWNERSHIP_MISMATCH";
    NcErrorType["ERR_INTERNAL_CUSTOMER_NOT_SUPPORTED"] = "ERR_INTERNAL_CUSTOMER_NOT_SUPPORTED";
    NcErrorType["ERR_SUBSCRIPTION_CREATE_FAILED"] = "ERR_SUBSCRIPTION_CREATE_FAILED";
    NcErrorType["ERR_STRIPE_WEBHOOK_VERIFICATION_FAILED"] = "ERR_STRIPE_WEBHOOK_VERIFICATION_FAILED";
    NcErrorType["ERR_API_CLIENT_NOT_FOUND"] = "ERR_API_CLIENT_NOT_FOUND";
    NcErrorType["ERR_EXTENSION_NOT_FOUND"] = "ERR_EXTENSION_NOT_FOUND";
    NcErrorType["ERR_SCRIPT_NOT_FOUND"] = "ERR_SCRIPT_NOT_FOUND";
    NcErrorType["FIELD_UNIQUE_CONSTRAINT_VIOLATION"] = "FIELD_UNIQUE_CONSTRAINT_VIOLATION";
    NcErrorType["ERR_METHOD_NOT_ALLOWED"] = "ERR_METHOD_NOT_ALLOWED";
    NcErrorType["ERR_INSUFFICIENT_PRIVILEGE"] = "ERR_INSUFFICIENT_PRIVILEGE";
    // Workflow Errors
    NcErrorType["ERR_WORKFLOW_EMPTY_NODE"] = "ERR_WORKFLOW_EMPTY_NODE";
    NcErrorType["ERR_WORKFLOW_TRIGGER_NODE_NOT_FOUND"] = "ERR_WORKFLOW_TRIGGER_NODE_NOT_FOUND";
    NcErrorType["ERR_WORKFLOW_NODE_EXECUTION_FAILED"] = "ERR_WORKFLOW_NODE_EXECUTION_FAILED";
    NcErrorType["ERR_WORKFLOW_MAX_ITERATIONS_EXCEEDED"] = "ERR_WORKFLOW_MAX_ITERATIONS_EXCEEDED";
    NcErrorType["ERR_WORKFLOW_NODE_NOT_FOUND"] = "ERR_WORKFLOW_NODE_NOT_FOUND";
    NcErrorType["ERR_WORKFLOW_WAITING_EXECUTIONS"] = "ERR_WORKFLOW_WAITING_EXECUTIONS";
})(NcErrorType || (NcErrorType = {}));
export var ROW_COLORING_MODE;
(function (ROW_COLORING_MODE) {
    ROW_COLORING_MODE["FILTER"] = "filter";
    ROW_COLORING_MODE["SELECT"] = "select";
})(ROW_COLORING_MODE || (ROW_COLORING_MODE = {}));
export var COLORING_TYPE;
(function (COLORING_TYPE) {
    COLORING_TYPE["ROW"] = "row";
    COLORING_TYPE["CELL"] = "cell";
})(COLORING_TYPE || (COLORING_TYPE = {}));
export const LongTextAiMetaProp = 'ai';
export const NO_SCOPE = 'nc';
export const NON_SEAT_ROLES = [
    WorkspaceUserRoles.NO_ACCESS,
    WorkspaceUserRoles.VIEWER,
    WorkspaceUserRoles.INHERIT,
    WorkspaceUserRoles.COMMENTER,
    ProjectRoles.NO_ACCESS,
    ProjectRoles.VIEWER,
    ProjectRoles.INHERIT,
    ProjectRoles.COMMENTER,
];
export const DURATION_TYPE_MAP = {
    0: 'h:mm',
    1: 'h:mm:ss',
    2: 'h:mm:ss.s',
    3: 'h:mm:ss.ss',
    4: 'h:mm:ss.sss',
    'h:mm': 0,
    'h:mm:ss': 1,
    'h:mm:ss.s': 2,
    'h:mm:ss.ss': 3,
    'h:mm:ss.sss': 4,
};
export const CURRENT_USER_TOKEN = '@me';
export var RowHeight;
(function (RowHeight) {
    RowHeight[RowHeight["SHORT"] = 0] = "SHORT";
    RowHeight[RowHeight["MEDIUM"] = 1] = "MEDIUM";
    RowHeight[RowHeight["TALL"] = 2] = "TALL";
    RowHeight[RowHeight["EXTRA"] = 3] = "EXTRA";
})(RowHeight || (RowHeight = {}));
export const RowHeightMap = {
    short: RowHeight.SHORT,
    medium: RowHeight.MEDIUM,
    tall: RowHeight.TALL,
    extra: RowHeight.EXTRA,
    [RowHeight.SHORT]: 'short',
    [RowHeight.MEDIUM]: 'medium',
    [RowHeight.TALL]: 'tall',
    [RowHeight.EXTRA]: 'extra',
};
export var DependencyTableType;
(function (DependencyTableType) {
    DependencyTableType["Column"] = "column";
    DependencyTableType["Model"] = "table";
    DependencyTableType["View"] = "view";
    DependencyTableType["Widget"] = "widget";
    DependencyTableType["Workflow"] = "workflow";
})(DependencyTableType || (DependencyTableType = {}));
export var BaseVersion;
(function (BaseVersion) {
    BaseVersion[BaseVersion["V2"] = 2] = "V2";
    BaseVersion[BaseVersion["V3"] = 3] = "V3";
})(BaseVersion || (BaseVersion = {}));
export var ManagedAppVersionStatus;
(function (ManagedAppVersionStatus) {
    ManagedAppVersionStatus["DRAFT"] = "draft";
    ManagedAppVersionStatus["PUBLISHED"] = "published";
})(ManagedAppVersionStatus || (ManagedAppVersionStatus = {}));
export var ManagedAppVisibility;
(function (ManagedAppVisibility) {
    ManagedAppVisibility["PUBLIC"] = "public";
    ManagedAppVisibility["PRIVATE"] = "private";
    ManagedAppVisibility["UNLISTED"] = "unlisted";
})(ManagedAppVisibility || (ManagedAppVisibility = {}));
export var DeploymentStatus;
(function (DeploymentStatus) {
    DeploymentStatus["PENDING"] = "pending";
    DeploymentStatus["IN_PROGRESS"] = "in_progress";
    DeploymentStatus["SUCCESS"] = "success";
    DeploymentStatus["FAILED"] = "failed";
})(DeploymentStatus || (DeploymentStatus = {}));
export var DeploymentType;
(function (DeploymentType) {
    DeploymentType["INSTALL"] = "install";
    DeploymentType["UPDATE"] = "update";
})(DeploymentType || (DeploymentType = {}));
//# sourceMappingURL=data:application/json;base64,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